<template>
  <div class="project-chat-container" v-if="groupChat">
    <group-chat-posts-container
      :groupChat="groupChat"
      class="flex-grow-1"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GroupChat from '@/store/models/GroupChat'
import Project from '@/store/models/Project'
import GroupChatPostsContainer from '@/components/organisms/GroupChatPostsContainer'

export default {
  name: 'ProjectMenuProjectChat',
  components: {
    GroupChatPostsContainer
  },
  props: {
    requiredAPIRequest: Boolean
  },
  computed: {
    projectId: function() { return this.$route.params.id },
    project: function() { return Project.find(this.projectId) },
    groupChat: function() {
      return GroupChat.find(this.project.projectChatId)
    }
  },
  methods: {
    ...mapActions({
      apiGetGroupChat: 'entities/groupChats/show',
      apiGetGroupChatPosts: 'entities/groupChatPosts/index'
    })
  },
  created() {
    this.apiGetGroupChat(this.project.projectChatId)
  }
}
</script>

<style scoped lang="scss">
.project-chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100% + 20px);
  margin-top: -20px;
}
</style>
